import { IconButton, TableCell, TableRow, Typography } from "@mui/material"
import { PropsWithChildren, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { ChevronRight } from "@mui/icons-material"
import { isEmpty } from "lodash"

const useStyles = makeStyles()((theme) => ({
    expandButton: {
        marginRight: "0.1rem",
    },
    expandButtonExpanded: {
        transform: "rotate(90deg)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.standard,
        }),
    },
}))

type ExpandableTableRowProps = Readonly<
    PropsWithChildren<{
        hasChildren?: boolean
        cellValue: string
        cellValue2: string
    }>
>

export function ExpandableTableRow({ cellValue, cellValue2, children }: ExpandableTableRowProps) {
    const { classes, cx } = useStyles()
    const [isExpanded, setIsExpanded] = useState(false)

    const hasChildren = !isEmpty(children)

    return (
        <>
            <TableRow
                key={cellValue}
                sx={{ cursor: hasChildren ? "pointer" : "" }}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <TableCell>
                    {hasChildren && (
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            disableRipple
                            className={cx(classes.expandButton, { [classes.expandButtonExpanded]: isExpanded })}
                        >
                            <ChevronRight />
                        </IconButton>
                    )}
                    <Typography variant="body2" sx={{ display: "inline", marginLeft: hasChildren ? "0" : "2.4rem" }}>
                        {cellValue}
                    </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: "end" }}></TableCell>
                <TableCell sx={{ textAlign: "end" }}>{cellValue2}</TableCell>
            </TableRow>

            {isExpanded && children}
        </>
    )
}
